import {Component, Input} from '@angular/core';
import {EmbedVideoType} from "../embed-video-type";
import {ObjectFit} from "../../ts-types/object-fit";
import {Video} from "../../interfaces/video";
import {ServerVideoService} from "../../services/server-video.service";

@Component({
  selector: 'brt-embed-video',
  templateUrl: './embed-video.component.html',
  styleUrls: ['./embed-video.component.scss']
})
export class EmbedVideoComponent {
  @Input('data') set setData(val: Video) {
    this.embedVideo = val;
    if (this.embedVideo.src.indexOf("youtube") !== -1) {
      this.embedVideoType = EmbedVideoType.YOUTUBE;

      let youtubeIframeStr = "";
      if (this.embedVideo.src.indexOf("/shorts/") !== -1) {
        youtubeIframeStr = this.serverVideoService.getYoutubeIframeShortsStringByVideo(val);
      } else {
        youtubeIframeStr = this.serverVideoService.getYoutubeIframeStringByVideo(val);
      }

      this.youtubeIframeStr = youtubeIframeStr;
    } else {
      console.error("Video type is not youtube!");
    }
  }

  @Input("object-fit") objectFit: ObjectFit = "contain";
  embedVideo!: Video;
  EmbedVideoType = EmbedVideoType;
  embedVideoType: EmbedVideoType = EmbedVideoType.YOUTUBE;
  youtubeIframeStr = "";

  constructor(private serverVideoService: ServerVideoService) {
  }

}
